import React from 'react';

const Add = () => {
    return (
        <div className='bg-dark text-light'>
            <div className='container'>
            <div className='row'>
                <div className='col-md-6 col-6'>
                    <p>
                        <i className="pe-3 fab fa-facebook-f"></i>
                        <i className="pe-3 fab fa-instagram"></i>
                        <i className="pe-3 fab fa-google-plus-g"></i>
                        <i className="pe-3 fas fa-globe-europe"></i>
                    </p>
                </div>
                <div className="col-md-6 d-flex flex-row-reverse col-6">
                    <p><i className="fas fa-phone-alt"></i>0180-0999992</p>
                </div>

            </div>
        </div>
        </div>
    );
};

export default Add;